import React, { Component } from 'react';

import AgreementBox from './agreement/AgreementBox';
import PoliciesAndConditions from './agreement/PoliciesAndConditions';

class CommonFooter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isModalVisible: false
        };

        this.onToggleClick = this.onToggleClick.bind(this);
    }

    onToggleClick() {
        this.setState(state => Object.assign({}, state, {
            isModalVisible: !state.isModalVisible
        }));
    }

    render() {
        const { isModalVisible } = this.state;
        return (
            <footer>
                <div className="container">
                    <div>2009-2017 Livingston Research Inc.</div>
                    <div>
                        Contact us: <a href="mailto:support@liv-research.com">support@liv-research.com</a>
                        <span className="dotted-devider">·</span>
                        Skype: <a href="skype:livingston_research">livingston_research</a>
                        <span className="dotted-devider">·</span>
                        <a onClick={this.onToggleClick}>Terms and Conditions &amp; Privacy Policy</a>
                    </div>
                </div>
                {isModalVisible &&
                    <AgreementBox onOverlayClick={this.onToggleClick}>
                        <PoliciesAndConditions />
                        <div className="ta-right mt20 agreement-info">
                            <span>You’ve already accepted this agreement.</span>
                            <button onClick={this.onToggleClick} type="button" className="btn btn-bright-success btn-md">Close</button>
                        </div>
                    </AgreementBox>
                }
            </footer>
        );
    }
}

export default CommonFooter;


// WEBPACK FOOTER //
// ./src/components/CommonFooter.js